import { Button, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import _ from 'lodash';
import styled from '@emotion/styled';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { selectValues } from '../../constants/roles';
import validator from 'validator'

const useStyles = makeStyles((theme) => ({
  left: {
    [theme.breakpoints.up('sm')]: {
      marginRight: '1.25rem',
    },
  },
  button: {
    marginTop: '2.875rem',
  },
  inputContainer: {
    width: '100%',
    marginBottom: '0.625rem',
  },
  input:{
    color: '#111111',
    width: '100%',
    border: 'none',
    outline: 'unset',
    fontSize: '1rem',
    boxSizing: 'border-box',
    fontFamily: 'Raleway',
    lineHeight: '1.1875rem',
    borderRadius: '0.3125rem',
    height: '3.125rem',
    padding: '1.0625rem 1.25rem',
    '&::placeholder': {
      color: '#444444',
    }
  },
  validPassword:{
    color: '#2cc92c',
  },
  invalidPassword:{
    color: '#ff3838',
  }
}));

const CustomSelect = styled(Select)(() => `
  .MuiSelect-select {
    background-color: white;
    color: #111111;
    width: 100%;
    border: none;
    outline: unset;
    font-size: 1rem;
    box-sizing: border-box;
    font-family: Raleway;
    line-height: 1.1875rem;
    border-radius: 0.3125rem;
    height: 3.125rem;
    padding: 1.0625rem 1.25rem;
    &:focus {
      background-color: white !important;
      border-radius: 4px !important;
    }
  }
`)

const UserForm = ({ form, handleChange, disabled, onSubmit, onCancel, edit, editPassword }) => {
  const classes = useStyles();

  const isDisabled = () => {

    //edit case
    if(edit){
      return disabled || !form.roleId 
    }

    //edit password case
    if(editPassword && (!form.password || !form.passwordConfirmation || !isPasswordValid())){
      return true
    }

    //create case
    if(!form.email || !form.roleId || !form.password || !form.passwordConfirmation){
      return true
    }

    return disabled || (form.password !== form.passwordConfirmation) || !isPasswordValid()
  }

  const isPasswordValid = () => {
    return validator.isStrongPassword(form.password,{
      minLength: 12,
      minLowercase: 1,
      minUppercase: 1,
      minSymbols: 1
    })
  }

  const getPasswordClassName = () => {
    if(form.password){
      return isPasswordValid() ? classes.validPassword : classes.invalidPassword
    }
    return ''
  }

  return (
    <form 
      onSubmit={(e) => { 
        e.preventDefault() 
        onSubmit()
      }
    }>
      <Grid container justify="center">
        <Grid item xs={6}>
          <div className={classes.inputContainer}>
            <input 
              className={classes.input} 
              type="email" 
              placeholder='Email' 
              value={form.email} 
              name='email'
              onChange={handleChange}
              required
              disabled={edit || editPassword}
            />
          </div>
          {
            !editPassword &&
            <div className={classes.inputContainer}>
              <FormControl variant='filled' fullWidth focused={false}>
                <CustomSelect 
                  value={form.roleId} 
                  onChange={handleChange} 
                  displayEmpty
                  name='roleId'
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return 'Select a role';
                    }
                    return selectValues[selected];
                  }}
                >
                  <MenuItem value={1}>Admin</MenuItem>
                  <MenuItem value={2}>User</MenuItem>
                </CustomSelect>
              </FormControl>
            </div>
          }
          {
            (!edit || editPassword) &&
            <>
              <div className={classes.inputContainer}>
                <input 
                  className={classes.input} 
                  type="password" 
                  placeholder='Password' 
                  value={form.password} 
                  name='password'
                  onChange={handleChange} 
                />
              </div>
              <div className={classes.inputContainer}>
                <input 
                  className={classes.input} 
                  type="password" 
                  placeholder='Confirm password' 
                  value={form.passwordConfirmation} 
                  name='passwordConfirmation'
                  onChange={handleChange} 
                />
              </div>
              <div className={getPasswordClassName()}>
                Password must contain at least 12 characters and at least 1 uppercase, 1 lowercase and 1 simbol
              </div>
            </>
          }
          
        </Grid>
      </Grid>
      <Grid container justify="center" direction="row" spacing={3}>
        <Grid item>
          <Button
            disabled={disabled}
            className={classes.button}
            variant="outlined" color="primary"
            onClick={onCancel}
            type='button'
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={isDisabled()}
            className={classes.button}
            variant="contained"
            color="primary"
            type='submit'
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

UserForm.defaultValue = {
  name: '',
  disabled: false,
};

export default UserForm;